export const Advance_Action_Types = {
    FETCH_ADVANCES_START: "advances/FETCH_ADVANCES_START",
    FETCH_ADVANCES_SUCCESS: "advances/FETCH_ADVANCES_SUCCESS",
    FETCH_ADVANCES_FAILED: "advances/FETCH_ADVANCES_FAILED",
    SET_FILTER_FROM_DATE: "advances/SET_FILTER_FROM_DATE",
    SET_FILTER_TO_DATE: "advances/SET_FILTER_TO_DATE",
    SET_FILTER_SEARCH_STRING: "advances/SET_FILTER_SEARCH_STRING"  
}